<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="活动报名"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="活动名称" label-width="85px">
          <!-- <el-input
            v-model="params.ActivityName"
            placeholder="请填写活动名称"
          ></el-input> -->
          <el-select
            v-model="params.ActivityId"
            placeholder="请选择活动"
            clearable
            filterable
          >
            <el-option
              v-for="item in actList"
              :key="item.RecordId"
              :label="item.ActivityName"
              :value="item.RecordId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" label-width="85px">
          <el-input
            v-model="params.PersonName"
            placeholder="请填写姓名"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="链接类型" label-width="85px">
            <el-select v-model="params.AdType" placeholder="请选择链接类型" clearable>
              <el-option label="静态展示" :value="0"></el-option>
              <el-option label="活动链接" :value="1"></el-option>
              <el-option label="外部页面链接" :value="2"></el-option>
             
            </el-select>
          </el-form-item> -->
      </template>
      <template slot="table">
        <!--<el-table-column prop="OrderId" label="序号" align="center" width="60" /> -->
        <el-table-column prop="ActivityName" label="活动名称" />
        <el-table-column prop="PersonName" label="姓名" />
        <el-table-column prop="PersonPhone" label="手机号码" />
        <el-table-column prop="EnrollTime" label="报名时间" />
        <!-- <el-table-column prop="ActivitySession" label="报名场次"/> -->
        <!-- <el-table-column prop="EnrollNumber" label="报名数量"/> -->
        <!-- <el-table-column prop="EnrollCost" label="缴费金额"/>
          <el-table-column prop="EnrollIntegral" label="抵扣积分"/> -->
        <!-- <el-table-column prop="AdType" label="链接类型">
            <template slot-scope="{row}">
              <span v-if="row.AdType==0">静态展示</span>
              <span v-else-if="row.AdType==1">活动链接</span>
              <span v-else-if="row.AdType==2">页面链接</span>
            </template>
          </el-table-column> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
//import editDialog from "./editDialog"

export default {
  mixins: [listMixin],
  components: {
    list,
    //editDialog
  },

  data() {
    return {
      api: require("@/api/operate/activityEnroll").default,
      params: {
        SectionId: "",
        ActivityId: null,
        PersonName: "",
        AdType: null,
      },
      actList: [],
    };
  },
  getData() {
    //  this.$refs.editDialog.getData({SectionId:SectionId});
  },
  beforeMount() {
    this.activityList();
  },
  mounted() {
    console.log(this.$route.params, "query");
    if (this.$route.params.ActivityId) {
      this.params.ActivityId = Number(this.$route.params.ActivityId);
      this.query(this.params);
    }
  },
  methods: {
    activityList() {
      this.api.getActivityList().then((res) => {
        if (res.Code == 0) {
          console.log(res.Data);
          this.actList = res.Data;
        }
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onExport() {
      this.api.export(this.params);
    },
  },
};
</script>